import AlEntityChangelogComponentController from './controller';
import template from './component.tpl.html';

angular
    .module('festzelt-os.modules.action_log')
    .component('alEntityChangeLog', {
        bindings: {
            entity: '<',
            entityId: '<',
            slugOverride: '<'
        },
        controller: AlEntityChangelogComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/action_log/components/entity-change-log/component.js